import { render, staticRenderFns } from "./NotificationConfiguration.vue?vue&type=template&id=67857ba0&scoped=true&"
import script from "./NotificationConfiguration.vue?vue&type=script&lang=ts&"
export * from "./NotificationConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationConfiguration.vue?vue&type=style&index=0&id=67857ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67857ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VList,VListItem,VTooltip})
